import { createContext } from 'react';

// Centralised here to break the circular dep:
// auth.context ← useUser ← useAuth ← auth.context
export interface User {
  id: string;
  name: string;
  email: string;
  password?: string;
  authToken?: string;
}

/** pending = check in flight | valid = token ok | invalid = logout triggered */
export type TokenStatus = 'pending' | 'valid' | 'invalid';

interface AuthContextValue {
  token: string | null;
  user: User | null;
  tokenStatus: TokenStatus;
  setUser: (user: User | null) => void;
}

export const AuthContext = createContext<AuthContextValue>({
  token: null,
  user: null,
  tokenStatus: 'pending',
  setUser: () => {},
});
